<template>
  <span class="LabelFunMessage"  v-if="messages" v-html="getLabel(fcontId,msgkey)"></span>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: 'LabelFunMessage',
  props: {
    fcontId: String,
    msgkey: String
  },
  computed: {
    ...mapState('messages', ['messages'])
  },
  methods: {
    getLabel : function (contId, key) {
      if(this.messages !== undefined){
        return this.messages[contId + '-' + key] || "";
      }
      return "";
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>